/* eslint-disable no-undefined */
/* eslint-disable prefer-template */
import Layout from "../../components/Layout";
import PageTitle from "../../components/PageTitle";
import Button from "../../components/Button";
import useStyles from "./styles";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import Modal from "../../components/Modal";
import ButtonCount from "../../components/ButtonCount";
import PageLoader from "../../components/PageLoader";
import TabContext from "@mui/lab/TabContext";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useEffect, useState } from "react";
import { Grid, useMediaQuery,
  Table as MuiTable,
  TableBody as MuiTableBody,
  TableCell as MuiTableCell,
  TableContainer as MuiTableContainer,
  TableHead as MuiTableHead,
  TableRow as MuiTableRow,
  Paper } from "@mui/material";
import Table from "../../components/Table/Table";
import SelectGroup from "../../components/FormComponent/SelectGroup";
import InputGroup from "../../components/FormComponent/InputGroup";
import TextAreaGroup from "../../components/FormComponent/TextAreaGroup";
import { TableSearch } from "../../components/Table/TableActions";
import { Gender } from "../../utils/DropDown";
import { toast } from "react-toastify";
import { httprequest } from "../../data/api";
import useValidator from "../../hooks/useValidator";
import Badge from "../../components/Badge";
import PopModal from "../../components/PopupModal/PopModal";
import CSVExport from "../../components/CsvExport/CsvExport";
import BulkStudentImport from "../../components/BulkStudentImport";
import { StudentModal, SuccessModal } from "./components/Modal";
// import useWindowSize from "../../hooks/useWindow";

// const EMPLOYEES_ENDPOINT = "/api/v1/employees";
const CLASSES_ENDPOINT = "/api/v1/class";
const STUDENT_ENDPOINT = "/api/v1/students";
const UPLOAD_ENDPOINT = "/api/v1/upload";
const BATCH_STUDENTS = "/api/v1/student-invite/batch";

const Student = () => {
  const [searchResult, setSearchResult] = useState([]);
  const classes = useStyles();
  const navigate = useNavigate();
  const [currentRow, setCurrentRow] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [broadcastModal, setBroadcastModal] = useState(false);
  const [createstudentmodal, setCreateStudentModal] = useState(false);
  const [isStudentsFetching, setIsStudentsFetching] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [uploadForm, setUploadForm] = useState({});
  const [studentData, setStudentsData] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [classData, setClassData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState("");
  const [studentValidator, showStudentValidation] = useValidator();
  const [activeStudent, setActiveStudent] = useState([]);
  const [searchactiveStudent, setSearchActiveStudent] = useState([]);
  const [searchinactiveStudent, setSearchInActiveStudent] = useState([]);
  const [inactiveStudent, setInActiveStudent] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [generatePassword, setGeneratePassword] = useState(false);
  const [createdGuardianCredentials, setCreatedGuardianCredentials] = useState({
    email: "",
    password: ""
  });
  const [copyModal, setCopyModal] = useState(false);
  const [bulkModal, setBulkModal] = useState(false);
  const [selectedClassId, setSelectedClassId] = useState("");
  const [isBulkLoading, setIsBulkLoading] = useState(false);
  const [allowUnverified, setAllowUnverified] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showEmailStatusModal, setShowEmailStatusModal] = useState(false);
  const [emailStatusTab, setEmailStatusTab] = useState("all");
  const [studentForm, setStudentForm] = useState({
    first_name: "",
    last_name: "",
    admission_date: "",
    class_admitted: "",
    email: "",
    contact: "",
    gender: "",
    age: ""
    // address: ""
  });
  const [tempAllowUnverified, setTempAllowUnverified] = useState(false);

  const [batchImportResult, setBatchImportResult] = useState({
    valid_emails: [],
    invalid_emails: [],
    students: []
  });
  const isMobile = useMediaQuery("(max-width:600px)");

  /**
 * Handles tab or UI view change event.
 * @param {SyntheticEvent} event - The event object.
 * @param {string} newValue - The new selected tab index.
 */
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  /**
 * Toggles the Create Student modal.
 */
  const handleCreateStudentModal = () => {
    setCreateStudentModal(!createstudentmodal);
    setGeneratePassword(false);
  };

  const handleCreateBulkModal = () => {
    setBulkModal(!bulkModal);
    setSelectedClassId("");
  };

  /**
 * Toggles the Broadcast modal.
 */
  const handleBroadcastModal = () => {
    setBroadcastModal(!broadcastModal);
  };

  const handleCopyModal = () => {
    setCopyModal(!copyModal);
  };

  /**
 * Removes the selected file.
 */
  const handleRemoveFile = () => setSelectedFile("");
  /**
 * Handles file input change and updates file state.
 * @param {Event} e - The file input change event.
 */
  const handleFileChange = (e) => {
    // const { name } = e.target;
    if (e.target.files) setSelectedFile(e.target.files[0]);
    setUploadForm({ ...uploadForm, file: e.target.files[0].name.replaceAll(" ", "-") });
  };

  /**
 * Opens delete modal for a specific student row.
 * @param {Object} row - The student data for deletion.
 */
  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  /**
 * Handles change in student form inputs.
 * @param {Event} e - The change event object from input.
 */
  const handleStudentChange = (e) => {
    const { name, value } = e.target;
    setStudentForm({ ...studentForm, [name]: value });
  };

  /**
 * Handles class selection change for bulk import.
 * @param {Event} e - The change event object from select.
 */
  const handleClassChange = (e) => {
    setSelectedClassId(e.target.value);
  };

  /**
 * Closes the delete modal.
 */
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  /**
 * Fetches all physical classes and updates the state.
 */
  const getAllClasses = () => {
    httprequest.get(CLASSES_ENDPOINT).then((res) => {
      const physicalClasses = res?.data?.data?.filter((data) => data?.class_type === "physical");
      setClassData(physicalClasses);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  /**
 * Fetches all students and separates them into active/inactive categories.
 * Also handles loading state and error toasts.
 */
  const getAllStudents = () => {
    setIsStudentsFetching(true);
    httprequest.get(STUDENT_ENDPOINT).then((res) => {
      setIsStudentsFetching(false);
      setActiveStudent(res?.data?.data?.filter((activeStudent) => activeStudent?.is_active === true));
      setInActiveStudent(res?.data?.data?.filter((inactiveStudent) => inactiveStudent?.is_active === false));
      setStudentsData(res?.data?.data);
      setSearchResult(res?.data?.data);
      setSearchActiveStudent(res?.data?.data?.filter((activeStudent) => activeStudent?.is_active === true));
      setSearchInActiveStudent(res?.data?.data?.filter((inactiveStudent) => inactiveStudent?.is_active === false));
    }).catch((err) => {
      setIsStudentsFetching(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
 * Handles bulk import of students from CSV file.
 * @param {File} file - The CSV file containing student data.
 */
  const handleCreateBatchStudent = async (file) => {
    if (!selectedClassId) {
      toast.error("Please select a class");

      return;
    }

    setIsBulkLoading(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("class_id", selectedClassId);
    formData.append("validate_email", allowUnverified ? "false" : "true");

    try {
      const res = await httprequest.post(BATCH_STUDENTS, formData);
      toast.success(res?.data?.message);
      setBulkModal(false);

      setTempAllowUnverified(allowUnverified);

      if (allowUnverified) {
        setShowSuccessModal(true);
        setAllowUnverified(false);
        setSelectedClassId("");
      } else {
        const transformedResult = {
          ...res.data,
          data: {
            ...res.data.data,
            students: [
              ...(res.data.data.valid_emails || []),
              ...(res.data.data.invalid_emails || [])
            ]
          }
        };
        setBatchImportResult(transformedResult);
        setShowSuccessModal(true);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
      setAllowUnverified(false);
    } finally {
      setIsBulkLoading(false);
    }
  };

  /**
 * Handles creation of a new student.
 * Includes form validation, optional file upload, and success/error handling.
 */
  const handleCreateStudent = async () => {
    if (studentValidator.allValid()) {
      setIsLoading(true);
      if (selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        const response = await httprequest.post(
          `${UPLOAD_ENDPOINT}`, formData
        );
        if (response.status === 200 && response.data.data) {
          const upload_id = response.data.data?.upload_id;

          const data = { ...studentForm, upload_id, generate_password: generatePassword };

          httprequest.post(STUDENT_ENDPOINT, data).then((res) => {
            setIsLoading(false);
            toast.success("Student successfully added to the school");
            getAllStudents();
            // --| Reset resource state to original state
            setStudentForm({ ...studentForm, first_name: "", last_name: "", admission_date: "", class_admitted: "",
              email: "", contact: "", gender: "", age: "" });
            handleCreateStudentModal();
            if (generatePassword && res.data?.data) {
              const passwordData = res?.data?.data;
              setCreatedGuardianCredentials({
                email: passwordData.email,
                password: passwordData.password
              });
              setCopyModal(true);
            }
          }).catch((err) => {
            setIsLoading(false);
            toast.error(err?.response?.data.message);
          });
        } else {
          setIsLoading(false);
          toast.error("There is a problem uploading the file");
        }
      } else {
        const formData = {
          ...studentForm,
          generate_password: generatePassword
        };
        httprequest.post(STUDENT_ENDPOINT, formData).then((res) => {
          setIsLoading(false);
          toast.success("Student successfully added to the school");
          getAllStudents();
          if (generatePassword && res.data?.data) {
            const passwordData = res?.data?.data;
            setCreatedGuardianCredentials({
              email: passwordData.email,
              password: passwordData.password
            });
            setCopyModal(true);
          }
          // --| Reset resource state to original state
          setStudentForm({ ...studentForm, first_name: "", last_name: "", admission_date: "", class_admitted: "",
            email: "", contact: "", gender: "", age: "" });
          handleCreateStudentModal();
        }).catch((err) => {
          setIsLoading(false);
          toast.error(err?.response?.data.message);
        });
      }
    } else {
      showStudentValidation(true);
    }
  };

  const handleSuccessModalDone = () => {
    setShowSuccessModal(false);
    if (tempAllowUnverified) {
      setTempAllowUnverified(false);
      setSelectedClassId("");
      getAllStudents();
    } else {
      setShowEmailStatusModal(true);
      setTempAllowUnverified(false);
    }
  };

  /**
 * Handles the deletion (deactivation) of a student.
 * Sends a DELETE request to the server, shows a toast on success/failure,
 * closes the modal, and refreshes the student list.
 */
  const handleDeleteStudent = () => {
    setIsDeleting(true);
    httprequest.delete(`${STUDENT_ENDPOINT}/${currentRow?.student_id}`).then((res) => {
      setIsDeleting(false);
      toast.success(res?.data?.message);
      handleCloseDeleteModal();
      getAllStudents();
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
 * Handles reactivating a previously deactivated student.
 * Sends a PATCH request to the server, shows a toast on success/failure,
 * closes the modal, and refreshes the student list.
 */
  const handleActivateStudent = () => {
    setIsDeleting(true);
    httprequest.patch(`${STUDENT_ENDPOINT}/${currentRow?.student_id}/reactivate`, { is_active: true }).then((res) => {
      setIsDeleting(false);
      toast.success(res?.data?.message);
      handleCloseDeleteModal();
      getAllStudents();
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
   * Initializes the component by setting the active students,
   * fetching all student records and class data on mount.
   */
  useEffect(() => {
    // The data will be from the Student get api endpint
    setActiveStudent(studentData);
    getAllStudents();
    getAllClasses();
  }, []);
  /**
 * Column definitions for the student data table.
 * Includes dynamic rendering for mobile and responsive data fields.
 */
  const columns = [
    {
      name: "Student Name",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Name</p>}
          {row?.student?.first_name + " " + row?.student?.last_name}
        </>
      )
    },
    {
      name: "Gender",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Gender</p>}
          {row?.gender || "--/--"}
        </>
      )
    },
    {
      name: "Class",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Class</p>}
          {row?.class?.name || "--/--"}
        </>
      )
    },
    // {
    //   name: "Status",
    //   center: "true",
    //   cell: (row) => <Badge status={row?.status} />
    // },
    {
      name: "No of Parent/Guardian",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">No of Parent/Guardian</p>}
          {/* {row?.guardian?.first_name || row?.guardian?.last_name
            ? `${row?.guardian?.first_name || ""} ${row?.guardian?.last_name || ""}`.trim()
            : "--/--"} */}
          {row?.guardians?.length}
        </>
      )
    },
    {
      name: "Contact",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Contact</p>}
          {row?.contact || "--/--"}
        </>
      )
    },
    {
      name: "Admission Date",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Admission Date</p>}
          {row?.admission_date.slice(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Status",
      cell: (row) => (<Badge status={row?.is_active} />)
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          {/* <button
            className="table-action-icon"
          >
            <Icon icon="ic:outline-folder" />
          </button> */}
          <Link to={`/users/students/${row?.student_id}`}>
            <button className="table-action-icon">
              <Icon icon="codicon:eye" />
            </button>
          </Link>
          <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon"
          >
            {row?.is_active === true ? <div className="delete-icon"><Icon icon="mingcute:delete-2-line" /></div>
              : <div className="approve-icon"><Icon icon="mdi:checkbox-marked-circle-outline" /></div>}
          </button>
          <button onClick={() => navigate(`/students/password/${row?.student_id}`)} className="table-action-icon">
            <Icon icon="material-symbols:key-outline-rounded" />
          </button>
        </div>
      )
    }
  ];

  /**
 * Handles search input for filtering the full student list (both active and inactive).
 * @param {React.ChangeEvent<HTMLInputElement>} e - The change event from the input field.
 */
  const handleSearchStudent = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = activeStudent?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                          data?.first_name
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                          data?.last_name
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                            data?.email
                              ?.toLowerCase()
                              .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
    setInActiveStudent(result);
  };

  /**
 * Filters only active students based on search keywords.
 * @param {React.ChangeEvent<HTMLInputElement>} e - The change event from the input field.
 */
  const handleSearchActiveStudent = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = studentData?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                          data?.first_name
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                          data?.last_name
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                            data?.email
                              ?.toLowerCase()
                              .includes(word.toLowerCase())
    )
    );
    setSearchActiveStudent(result);
  };

  /**
 * Filters only inactive students based on search keywords.
 * @param {React.ChangeEvent<HTMLInputElement>} e - The change event from the input field.
 */
  const handleSearchInActiveStudent = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = inactiveStudent?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                          data?.first_name
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                          data?.last_name
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                            data?.email
                              ?.toLowerCase()
                              .includes(word.toLowerCase())
    )
    );
    setSearchInActiveStudent(result);
  };

  /**
 * Destructures the student form state for easy access to individual fields.
 * @typedef {Object} StudentForm
 * @property {string} first_name - First name of the student
 * @property {string} last_name - Last name of the student
 * @property {string} admission_date - Admission date
 * @property {string} class_admitted - Class admitted to
 * @property {string} email - Email address
 * @property {string} contact - Contact number
 * @property {string} gender - Gender of the student
 * @property {number} age - Age of the student
 */
  const { first_name, last_name, admission_date, class_admitted, email, contact,
    gender, age } = studentForm;

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="All Students"
            subtitle="See the details of the students in your school"
            button={
              <div className="flex gap-10">
                <PopModal videoUrl="https://youtu.be/rtusCt4zdrE" title="students" />
                <Button
                  variant="primaryoutline"
                  buttonSize="fluid"
                  color="btnfontprimary"
                  onClick={handleCreateBulkModal}
                  buttonName="Import Batch Students"
                />
                <Button
                  variant="primary"
                  buttonSize="small"
                  color="btndefault"
                  // onClick={handleCreateStudentModal}
                  onClick={() => navigate("/users/create-student")}
                  buttonName="Create Students"
                />
              </div>
            }
          />
          <div className={classes.pageContent}>
            <div className={`${classes.buttoncountcontainer} padding-left-16`}>
              <ButtonCount title="Total Student Count" count={value === "" ? studentData?.length : value === "active" ? activeStudent?.length : inactiveStudent?.length} />
            </div>
            <TabContext value={value}>
              {studentData?.length > 0 && (
                <div className="tablist-container padding-left-16">
                  <Tabs className="overide-tablist" onChange={handleChange} aria-label="lab API tabs example">
                    <Tab label="All" value="" />
                    <Tab label="Active" value="active" />
                    <Tab label="Inactive" value="inactive" />
                    {/* <Tab label="Terminated Staff" value="terminated" /> */}
                  </Tabs>
                </div>
              )}
              {isStudentsFetching ? (
                <PageLoader />
              ) : (
                <>
                  <TabPanel value="" className="tabpanel-overide">
                    <Table
                      data={searchResult}
                      columns={columns}
                      subHeader={true}
                      pagination
                      isLoading={isStudentsFetching}
                      handleRowSelected={({ selectedRows }) => setSelectedRows(selectedRows.map(row => row.student_id))}
                      subHeaderComponent={
                        studentData?.length > 0 && (
                          <div className="action_div">
                            <TableSearch
                              placeholder="Search here..."
                              searchTableFunc={handleSearchStudent}
                            />
                            <CSVExport
                              data={searchResult}
                              filename="Student_export"
                              idKey="student_id"
                              selectedRows={selectedRows}
                              fields={[
                                { path: "email", header: "Email Address" },
                                { path: "full_name", header: "Full Name" },
                                { path: "contact", header: "Phone Number" },
                                { path: "class_admitted", header: "Class" },
                                { path: "admission_date", header: "Adminssion Date" },
                                { path: "gender", header: "Gender" },
                                { path: "age", header: "Age" }
                              ]}
                            />
                          </div>
                        )}
                    />
                    {/* Teachers data={employeesData?.filter(active => active?.is_active === true)} */}
                  </TabPanel>
                  <TabPanel value="active" className="tabpanel-overide">
                    <Table
                      data={searchactiveStudent}
                      columns={columns}
                      subHeader={true}
                      pagination
                      isLoading={isStudentsFetching}
                      handleRowSelected={({ selectedRows }) => setSelectedRows(selectedRows.map(row => row.student_id))}
                      subHeaderComponent={
                        studentData?.length > 0 && (
                          <div className="action_div">
                            <TableSearch
                              placeholder="Search here..."
                              searchTableFunc={handleSearchActiveStudent}
                            />
                            <CSVExport
                              data={searchactiveStudent}
                              filename="Student_export"
                              idKey="student_id"
                              selectedRows={selectedRows}
                              fields={[
                                { path: "email", header: "Email Address" },
                                { path: "full_name", header: "Full Name" },
                                { path: "contact", header: "Phone Number" },
                                { path: "class_admitted", header: "Class" },
                                { path: "admission_date", header: "Adminssion Date" },
                                { path: "gender", header: "Gender" },
                                { path: "age", header: "Age" }
                              ]}
                            />
                          </div>
                        ) }
                    />
                  </TabPanel>
                  <TabPanel value="inactive" className="tabpanel-overide">
                    <Table
                      data={searchinactiveStudent}
                      columns={columns}
                      subHeader={true}
                      pagination
                      isLoading={isStudentsFetching}
                      subHeaderComponent={
                        studentData?.length > 0 && (
                          <TableSearch
                            placeholder="Search here..."
                            searchTableFunc={handleSearchInActiveStudent}
                          />
                        )}
                    />
                  </TabPanel>
                </>
              )}
            </TabContext>
          </div>
          {/* Submit Examination Modal */}
          <Modal
            title="Add a Student to your school."
            subtitle={
              <div> Add a student to your school, it sends an invite email to them which gives them access to login on their app
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="First Name"
                      required
                      margin="normal"
                      inputType="text"
                      inputName="first_name"
                      value={first_name}
                      onChange={handleStudentChange}
                    />
                    {studentValidator.message("First Name", first_name, "required")}
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      required
                      label="Last Name"
                      margin="normal"
                      inputType="text"
                      inputName="last_name"
                      value={last_name}
                      onChange={handleStudentChange}
                    />
                    {studentValidator.message("Last Name", last_name, "required")}
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Student Email"
                      required
                      margin="normal"
                      placeHolder="Enter email"
                      inputType="email"
                      inputName="email"
                      value={email}
                      onChange={handleStudentChange}
                    />
                    {studentValidator.message("Email", email, "required")}
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Age"
                      required
                      margin="normal"
                      inputType="number"
                      inputName="age"
                      value={age}
                      onChange={handleStudentChange}
                    />
                    {studentValidator.message("Age", age, "required")}
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Student Contact"
                      required
                      margin="normal"
                      inputType="tel"
                      inputName="contact"
                      value={contact}
                      onChange={handleStudentChange}
                    />
                    {studentValidator.message("Contact", contact, "required")}
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Admission Date"
                      required
                      margin="normal"
                      inputType="date"
                      inputName="admission_date"
                      value={admission_date}
                      onChange={handleStudentChange}
                    />
                    {studentValidator.message("admission date", admission_date, "required")}
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup required label="Class Admitted to" children={
                      <select value={class_admitted} name="class_admitted" onChange={handleStudentChange}>
                        <option value="">---Select Labels ---</option>
                        {classData?.map((data) => {
                          return (
                            <option key={data?.id} value={data?.id}>{data?.class_name}</option>
                          );
                        })}
                      </select>
                    }
                    />
                    {studentValidator.message("class admitted", class_admitted, "required")}
                  </Grid>
                  {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Address"
                      margin="normal"
                      inputType="text"
                      inputName="address"
                      value={address}
                      onChange={handleStudentChange}
                    />
                  </Grid> */}
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup required label="Gender" children={
                      <select value={gender} name="gender" onChange={handleStudentChange}>
                        <option value="">---Select  ---</option>
                        {Gender?.map((gend) => {
                          return (
                            <option key={gend?.key} value={gend?.key}>{gend?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                    {studentValidator.message("Gender", gender, "required")}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <label className={`${classes.label}`}>Upload supporting documents<span className="input-required">*</span> </label>
                    <div className={classes.pickercontainer}>
                      <input type="file" className={classes.picker} onChange={handleFileChange} name="file" accept=".pdf" />

                      <div className={classes.uploadflex}>
                        <div><Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} /></div>
                        {selectedFile?.name ? (
                          <div>
                            <h2 className={classes.uploadtitle}>{selectedFile?.name}</h2>
                          </div>
                        ) :
                          <div>
                            <p className={classes.uploadtitle}>Tap to Upload</p>
                            <p className={classes.uploadsubtitle}>PDF | 10MB max.
                            </p>
                          </div>}
                      </div>
                      <div className={classes.rightpicker}>
                        {selectedFile?.name ? (
                          <div className={classes.uploadbutton} onClick={handleRemoveFile}><Icon icon="zondicons:minus-solid" /> Remove File</div>
                        ) : null}
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className={classes.check}>
                      <input
                        type="checkbox"
                        checked={generatePassword}
                        onChange={(e) => setGeneratePassword(e.target.checked)}
                      />
                      <label className="checkbox-label" htmlFor="">
                        Generate password
                      </label>
                    </div>

                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <div className={classes.modalFooterBtn}>
                  <Button variant="primaryoutline" buttonSize="full" color="btnfontprimary" buttonName="Cancel" />
                  <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Add Student" onClick={handleCreateStudent} isLoading={isLoading} />
                </div>
              </>
            }
            isopen={createstudentmodal}
            closeModal={handleCreateStudentModal}
          />
          {/* Send Broadcast Modal */}
          <Modal
            title="Send Broadcast to parents."
            subtitle={
              <div>Send a broadcast message to the parents of the students in this class
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Broadcast To:"
                      required
                      margin="normal"
                      placeHolder="Parent Email"
                      inputType="text"
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextAreaGroup
                      label="Broadcast Message"
                      required
                      margin="normal"
                      placeholder="Enter the message you will like to share with the parents."
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <label className={`${classes.label}`}>Additional Information <span className="input-required">*</span></label>
                    <div className={classes.pickercontainer}>
                      <input type="file" className={classes.picker} />

                      <div className={classes.uploadflex}>
                        <div><Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} /></div>
                        <div>
                          <h2 className={classes.uploadtitle}>Tap to Upload</h2>
                          <h6 className={classes.uploadsubtitle}>SVG,PNG,JPG,GIF| 10MB max.</h6>
                        </div>
                      </div>
                      <div className={classes.rightpicker}>
                        <div className={classes.uploadbutton}>Upload</div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <div className={classes.modalFooterBtn}>
                  <Button variant="primaryoutline" buttonSize="full" color="btnfontprimary" buttonName="Cancel" />
                  <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Broadcast" />
                </div>
              </>
            }
            isopen={broadcastModal}
            closeModal={handleBroadcastModal}
          />

          {/* Bulk Import Modal */}
          <Modal
            title="Import Batch Students"
            subtitle={
              <div>Create multiple students at the same time by importing a csv file.
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup
                      required
                      label="Select Class"
                      children={
                        <select value={selectedClassId} name="class_id" onChange={handleClassChange}>
                          <option value="">---Select Class ---</option>
                          {classData?.map((data) => {
                            return (
                              <option key={data?.id} value={data?.id}>{data?.class_name}</option>
                            );
                          })}
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <p className="key-pair-name">1. Download sample .csv file here.</p>
                    <p className="key-pair-name">2. Fill in all columns. All fields are mandatory.</p>
                    <p className="key-pair-name">3. Do not include extra columns nor rename columns in the document.</p>
                    <p className="key-pair-name">4. Upload the completed excel document</p>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <BulkStudentImport
                      createClick={(file) => handleCreateBatchStudent(file)}
                      isLoading={isBulkLoading}
                      allowUnverified={allowUnverified}
                      setAllowUnverified={setAllowUnverified}
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={<></>}
            isopen={bulkModal}
            closeModal={handleCreateBulkModal}
          />

          {/* Delete Modal */}
          <Modal
            title={currentRow?.is_active === true ? "Delete Student" : "Re-activate Student"}
            subtitle={
              currentRow?.is_active === true
                ? (
                  <div>
                    Are you sure you want to delete
                    <span className="modal-name-highlight"> {`${currentRow?.student?.last_name} ${currentRow?.student?.first_name}`}</span>?
                    Deleting is a permanent action
                  </div>
                )
                : (
                  <div>
                    Are you sure you want to re-activate
                    <span className="modal-name-highlight"> {`${currentRow?.student?.last_name} ${currentRow?.student?.first_name}`}</span>?
                    If re-activated, the student will have access to this platform.
                  </div>
                )
            }
            modalContent={
              <>

              </>
            }
            modalFooter={
              <>
                {currentRow?.is_active === true ? <Button variant="danger" buttonName="Delete Student Information" isLoading={isDeleting} onClick={handleDeleteStudent} buttonSize="full" color="btndefault" />
                  : <Button onClick={handleActivateStudent} variant="primary" buttonName="Re-activate Student" isLoading={isDeleting} buttonSize="full" color="btndefault" />}
              </>
            }
            isopen={deleteModal}
            closeModal={handleCloseDeleteModal}
          />
          <Modal
            title="Student Successfully Created"
            subtitle="Please send to the immediately because you wont be able to see this password again"
            modalContent={
              <div className={classes.copy}>
                <Grid container spacing={2} className={classes.copy_div}>
                  <Grid item lg={6} md={6} sm={12} xs={12}
                    className={classes.details}
                  >
                    <span className={classes.details_span}>Email Address</span>
                    <p className={classes.details_p}>{createdGuardianCredentials.email || "Not available"}</p>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}
                    className={classes.details}
                  >
                    <span className={classes.details_span}>Password</span>
                    <p className={classes.details_p}>{createdGuardianCredentials.password || "Not available"}</p>
                  </Grid>
                </Grid>

                <div className={classes.note}> <Icon icon="fluent:info-16-regular" width="16" height="16" />NB: Copy and send right away, you wont be able to send it after now</div>
              </div>
            }
            modalFooter={
              <>
                <Button variant="primary" buttonName="Copy" buttonSize="full" color="btndefault" onClick={() => {
                  navigator.clipboard.writeText(
                    `Email: ${createdGuardianCredentials.email}\nPassword: ${createdGuardianCredentials.password}`
                  );
                  toast.success("Copied to clipboard!");
                }}
                />
              </>
            }
            isopen={copyModal}
            closeModal={handleCopyModal}
          />

          {/* Email Status Modal */}
          <Modal
            title="Import Summary"
            subtitle={<div>Review the import results below.</div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item xs={12}>
                    <TabContext value={emailStatusTab}>
                      <div className="tablist-container">
                        <Tabs
                          className="overide-tablist"
                          onChange={(event, newValue) => setEmailStatusTab(newValue)}
                          value={emailStatusTab}
                        >
                          <Tab label={`All Students (${batchImportResult?.data?.students?.length || 0})`} value="all" />
                          <Tab label={`Valid Emails (${batchImportResult?.data?.valid_emails?.length || 0})`} value="valid" />
                          <Tab label={`Invalid Emails (${batchImportResult?.data?.invalid_emails?.length || 0})`} value="invalid" />
                        </Tabs>
                      </div>

                      <TabPanel value="all" className="tabpanel-overide" style={{ padding: 0 }}>
                        {batchImportResult?.data?.students && batchImportResult?.data?.students?.length > 0 ? (
                          <MuiTableContainer component={Paper} className={classes.tableContainer}>
                            <MuiTable className={classes.table} aria-label="all students table">
                              <MuiTableHead className={classes.tableHead}>
                                <MuiTableRow>
                                  <MuiTableCell className={classes.tableHeader}>Student Name</MuiTableCell>
                                  <MuiTableCell className={classes.tableHeader}>Email</MuiTableCell>
                                  <MuiTableCell className={classes.tableHeader}>Admission No</MuiTableCell>
                                  <MuiTableCell className={classes.tableHeader}>Status</MuiTableCell>
                                </MuiTableRow>
                              </MuiTableHead>
                              <MuiTableBody>
                                {batchImportResult?.data?.students?.map((student, index) => (
                                  <MuiTableRow
                                    key={index}
                                    className={`${classes.tableRow}`}
                                  >
                                    <MuiTableCell className={classes.tableCell}>
                                      <span className={classes.studentName}>
                                        {student.first_name} {student.last_name}
                                      </span>
                                    </MuiTableCell>
                                    <MuiTableCell className={classes.tableCell}>
                                      <span className={classes.studentEmail}>{student.email}</span>
                                    </MuiTableCell>
                                    <MuiTableCell className={classes.tableCell}>
                                      <span className={classes.studentPassword}>
                                        {student.admission_number || "N/A"}
                                      </span>
                                    </MuiTableCell>
                                    <MuiTableCell className={classes.tableCell}>
                                      {student.email_valid ? (
                                        <span className={classes.validBadge}>Valid Email</span>
                                      ) : (
                                        <span className={classes.invalidBadge}>Invalid Email</span>
                                      )}
                                    </MuiTableCell>
                                  </MuiTableRow>
                                ))}
                              </MuiTableBody>
                            </MuiTable>
                          </MuiTableContainer>
                        ) : (
                          <div className={classes.noDataMessage}>
                  No student data available
                          </div>
                        )}
                      </TabPanel>

                      <TabPanel value="valid" className="tabpanel-overide" style={{ padding: 0 }}>
                        {batchImportResult?.data?.valid_emails && batchImportResult?.data?.valid_emails?.length > 0 ? (
                          <MuiTableContainer component={Paper} className={classes.tableContainer}>
                            <MuiTable className={classes.table} aria-label="valid emails table">
                              <MuiTableHead className={classes.tableHead}>
                                <MuiTableRow>
                                  <MuiTableCell className={classes.tableHeader}>Student Name</MuiTableCell>
                                  <MuiTableCell className={classes.tableHeader}>Email</MuiTableCell>
                                  <MuiTableCell className={classes.tableHeader}>Admission No</MuiTableCell>
                                  <MuiTableCell className={classes.tableHeader}>Status</MuiTableCell>
                                </MuiTableRow>
                              </MuiTableHead>
                              <MuiTableBody>
                                {batchImportResult?.data?.valid_emails
                                  .map((student, index) => (
                                    <MuiTableRow key={index} className={classes.tableRow}>
                                      <MuiTableCell className={classes.tableCell}>
                                        <span className={classes.studentName}>
                                          {student.first_name} {student.last_name}
                                        </span>
                                      </MuiTableCell>
                                      <MuiTableCell className={classes.tableCell}>
                                        <span className={classes.studentEmail}>{student.email}</span>
                                      </MuiTableCell>
                                      <MuiTableCell className={classes.tableCell}>
                                        <span className={classes.studentPassword}>
                                          {student.admission_number || "N/A"}
                                        </span>
                                      </MuiTableCell>
                                      <MuiTableCell className={classes.tableCell}>
                                        <span className={classes.validBadge}>Valid Email</span>
                                      </MuiTableCell>
                                    </MuiTableRow>
                                  ))}
                              </MuiTableBody>
                            </MuiTable>
                          </MuiTableContainer>
                        ) : (
                          <div className={classes.noDataMessage}>
                  No valid email data available
                          </div>
                        )}
                      </TabPanel>

                      <TabPanel value="invalid" className="tabpanel-overide" style={{ padding: 0 }}>
                        {batchImportResult?.data?.invalid_emails && batchImportResult?.data?.invalid_emails?.length > 0 ? (
                          <>
                            <MuiTableContainer component={Paper} className={classes.tableContainer}>
                              <MuiTable className={classes.table} aria-label="invalid emails table">
                                <MuiTableHead className={classes.tableHead}>
                                  <MuiTableRow>
                                    <MuiTableCell className={classes.tableHeader}>Student Name</MuiTableCell>
                                    <MuiTableCell className={classes.tableHeader}>Email</MuiTableCell>
                                    <MuiTableCell className={classes.tableHeader}>Admission No</MuiTableCell>
                                    <MuiTableCell className={classes.tableHeader}>Status</MuiTableCell>
                                  </MuiTableRow>
                                </MuiTableHead>
                                <MuiTableBody>
                                  {batchImportResult?.data?.invalid_emails
                                    .map((student, index) => (
                                      <MuiTableRow key={index} className={`${classes.tableRow}`}>
                                        <MuiTableCell className={classes.tableCell}>
                                          <span className={classes.studentName}>
                                            {student.first_name} {student.last_name}
                                          </span>
                                        </MuiTableCell>
                                        <MuiTableCell className={classes.tableCell}>
                                          <span className={classes.studentEmail}>{student.email}</span>
                                        </MuiTableCell>
                                        <MuiTableCell className={classes.tableCell}>
                                          <span className={classes.studentPassword}>
                                            {student.admission_number || "N/A"}
                                          </span>
                                        </MuiTableCell>
                                        <MuiTableCell className={classes.tableCell}>
                                          <span className={classes.invalidBadge}>Invalid Email</span>
                                        </MuiTableCell>
                                      </MuiTableRow>
                                    ))}
                                </MuiTableBody>
                              </MuiTable>
                            </MuiTableContainer>
                          </>
                        ) : (
                          <div className={classes.noDataMessage}>
                  No invalid email data available
                          </div>
                        )}
                      </TabPanel>
                    </TabContext>
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <div className={classes.modalFooterBtn}>
                {batchImportResult?.data?.invalid_emails?.length > 0 ?
                  <Button
                    variant="primaryoutline"
                    buttonName="Download Invalid Emails CSV"
                    buttonSize="full"
                    color="btnfontprimary"
                    onClick={() => {
                      const csvHeaders = ["first_name", "last_name", "email", "gender", "age", "admission_date"];
                      const csvData = batchImportResult?.data?.invalid_emails.map(student => [
                        student.first_name || "",
                        student.last_name || "",
                        student.email || "",
                        student.gender || "",
                        student.age || "",
                        student.admission_date || ""
                      ]);

                      const csvContent = [csvHeaders, ...csvData]
                        .map(row => row.map(field => `"${field}"`).join(","))
                        .join("\n");

                      const blob = new Blob([csvContent], { type: "text/csv" });
                      const url = window.URL.createObjectURL(blob);
                      const link = document.createElement("a");
                      link.href = url;
                      link.setAttribute("download", "invalid_emails.csv");
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                      window.URL.revokeObjectURL(url);

                      toast.success("Invalid emails CSV downloaded successfully");
                    }}
                  />
                  : null
                }
                <Button
                  variant="primary"
                  buttonName="Close"
                  buttonSize="full"
                  color="btndefault"
                  onClick={() => setShowEmailStatusModal(false)}
                />
              </div>
            }
            isopen={showEmailStatusModal}
            closeModal={() => setShowEmailStatusModal(false)}
          />
          <StudentModal isOpen={showSuccessModal} onClose={() => setShowSuccessModal(false)}>
            <SuccessModal onDone={handleSuccessModalDone} />
          </StudentModal>
          {/* <Modal isOpen={showWarningModal} onClose={() => setShowWarningModal(false)}>
            <WarningModal onDownload={handleDownloadInvalidEmails} />
          </Modal> */}
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default Student;
